export default __webpack_public_path__ + "static/media/2_0118.b845852d.webp";